export const faqQuestions = [
  { id: 1, step: 'Step1PartnerRegistration', text: 'How do I get hub id?' },
  { id: 2, step: 'Step1PartnerRegistration', text: 'What is the login URL?' },
  { id: 3, step: 'Step1PartnerRegistration', text: 'How do I get the property id?' },
  {
    id: 4,
    step: 'Step2ApiUserRegistration',
    text: 'How do I get the interface id and interface key?'
  }
]
